function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = false,
  onConfirm,
  onCancel
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={titleStyle}>{title}</h2>

        <p style={messageStyle}>{message}</p>

        <div style={buttonRowStyle}>
          <button onClick={onCancel} style={cancelButtonStyle}>
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            style={{
              ...confirmButtonStyle,
              backgroundColor: danger ? "#e10600" : "#e10600"
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.72)",
  zIndex: 30000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px"
};

const modalStyle = {
  width: "100%",
  maxWidth: "420px",
  backgroundColor: "#111",
  color: "white",
  border: "1px solid #2b2b2b",
  borderRadius: "20px",
  padding: "24px",
  boxShadow: "0 20px 50px rgba(0,0,0,0.55)"
};

const titleStyle = {
  margin: "0 0 10px",
  fontSize: "24px"
};

const messageStyle = {
  margin: "0 0 24px",
  opacity: 0.82,
  lineHeight: "1.55"
};

const buttonRowStyle = {
  display: "flex",
  gap: "12px",
  justifyContent: "flex-end",
  flexWrap: "wrap"
};

const cancelButtonStyle = {
  padding: "12px 16px",
  borderRadius: "10px",
  border: "1px solid #333",
  backgroundColor: "#181818",
  color: "white",
  cursor: "pointer",
  fontWeight: "bold"
};

const confirmButtonStyle = {
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  color: "white",
  cursor: "pointer",
  fontWeight: "bold"
};

export default ConfirmModal;